export const PickmupTheme = {
  name: 'Pickmup Theme',
  themeId: 'pickmup',
  colors: {
    brand: {
      primary: {
        100: '#39abdb'
      },
      secondary: {
        100: '#2390be'
      },
      accent: {
        100: '#39abdb'
      },
      alternative: {
        100: '#39abdb'
      }
    }
  },
  backgrounds: {
    tile: '#39abdb'
  }
};